import { reactive, watch } from 'vue'

import { createPartModel } from './createPartModel'

import type {
  IFromMeta // 表单控件需要的 meta
} from '../../types/30-form'

import type { IFormItemList } from '../../types/20-form-item'

type ShowCol = {
  [id: number | string]: boolean
}
/**
 * 设置备选项和子控件的联动
 * @param formMeta 表单控件的meta
 * @param model 表单完整的 model
 * @param partModel 表单部分 的 model
 * @returns 
 */
export const setControlShow = (
  formMeta: IFromMeta,
  itemMeta: IFormItemList,
  model: any,
  partModel: any
) => {
  
  const {
    linkageMeta,
    colOrder
  } = formMeta
  
  // 设置字段的是否可见
  const showCol = reactive<ShowCol>({})
  // 依据meta设置，默认都可见
  const setShow = () => {
    if (typeof itemMeta === 'object') {
      for (const key in itemMeta) {
        showCol[key] = true
      }
    }
  }

  // 设置联动
  const setFormColShow = () => {
    setShow()
    // 数据变化，联动组件的显示
    if (typeof linkageMeta === 'object' && Object.keys(linkageMeta).length > 0) {
      for (const key in linkageMeta) {
        const ctl = linkageMeta[key]
        const colName = itemMeta[key].formItemMeta.colName
        // 监听组件的值，有变化就重新设置局部 model
        if (typeof model[colName] !== 'undefined') {
          watch(() => model[colName], (v1, v2) => {
            if (v1 === null) {
              // 清空选项，设为全部可见
              Object.keys(itemMeta).forEach(key => {
                showCol[key] = true
              })
            } else if (typeof ctl[v1] !== 'undefined') {
              // 判断是不是bool类型。
              if (typeof v1 === 'boolean') {
                // 设置指定的控件是否可见，其他控件不设置
                ctl[v1].forEach((id: any) => {
                  let _id = id
                  let bl = v1
                  if (Array.isArray(id)) {
                    _id = id[0]
                    // 设置子控件的值
                    const colName = itemMeta[_id].formItemMeta.colName
                    model[colName] = id[1]
                  }
                  // 字符串形式的ID，取反
                  if (typeof _id === 'string' ) {
                    bl = !v1
                  }
                  showCol[_id] = bl // 以 父级控件的值为准
                })
              } else {
                Object.keys(itemMeta).forEach(key => {
                  showCol[key] = false
                })
                ctl[v1].forEach(id => {
                  showCol[id] = true
                })
              }
              // 设置部分的 model
              createPartModel(model, partModel, itemMeta, showCol)
            }
          },
          { immediate: true })
        }
      }
      // 监听完整model的值的变化，同步值
      if (typeof partModel !== 'undefined') {
        watch(model, () => {
          for (const key in model) {
            if (typeof(partModel[key]) !== 'undefined') {
              partModel[key] = model[key]
            }
          }
        })
      }
    }
  }
  setFormColShow()
  watch(() => colOrder, (order) => {
    order.forEach((id: string | number) => {
      showCol[id] = true
    })
    // setFormColShow()
  })
  
  return {
    showCol,
    setFormColShow
  }
}